(function () {
  const states = new Set();

  let pointerX = -10000;
  let pointerY = -10000;
  let animationFrame = null;

  const desktopQuery = window.matchMedia(
    "(min-width: 750px) and (hover: hover) and (pointer: fine)"
  );

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), maximum);
  }

  function initialise(root) {
    if (!root || root.dataset.proximityInitialised === "true") {
      return;
    }

    const text = root.querySelector(".proximity-text__content");

    if (!text) return;

    root.dataset.proximityInitialised = "true";

    const maximumBlur = Number(root.dataset.maxBlur) || 14;
    const maximumDistance = Number(root.dataset.maxDistance) || 500;

    states.add({
      root: root,
      text: text,
      maximumBlur: maximumBlur,
      maximumDistance: maximumDistance,
      currentBlur: maximumBlur,
      targetBlur: maximumBlur
    });

    text.style.setProperty(
      "--cursor-blur",
      maximumBlur + "px"
    );
  }

  function initialiseAll(container) {
    if (!container) return;

    if (
      container.nodeType === 1 &&
      container.matches("[data-proximity-text]")
    ) {
      initialise(container);
    }

    if (container.querySelectorAll) {
      container
        .querySelectorAll("[data-proximity-text]")
        .forEach(initialise);
    }
  }

  function calculateTargets() {
    if (!desktopQuery.matches) return;

    states.forEach(function (state) {
      if (!state.root.isConnected) {
        states.delete(state);
        return;
      }

      const rect = state.text.getBoundingClientRect();

      /*
       * Measures distance from the cursor to the nearest
       * edge of the text—not merely its centre.
       *
       * This makes blur exactly zero while hovering.
       */
      const distanceX = Math.max(
        rect.left - pointerX,
        0,
        pointerX - rect.right
      );

      const distanceY = Math.max(
        rect.top - pointerY,
        0,
        pointerY - rect.bottom
      );

      const distance = Math.hypot(distanceX, distanceY);

      const blurProgress = clamp(
        distance / state.maximumDistance,
        0,
        1
      );

      state.targetBlur =
        blurProgress * state.maximumBlur;
    });

    startAnimation();
  }

  function startAnimation() {
    if (animationFrame !== null) return;

    animationFrame = requestAnimationFrame(animate);
  }

  function animate() {
    let stillMoving = false;

    states.forEach(function (state) {
      if (!state.root.isConnected) {
        states.delete(state);
        return;
      }

      const difference =
        state.targetBlur - state.currentBlur;

      state.currentBlur += difference * 0.12;

      if (Math.abs(difference) < 0.02) {
        state.currentBlur = state.targetBlur;
      } else {
        stillMoving = true;
      }

      state.text.style.setProperty(
        "--cursor-blur",
        state.currentBlur.toFixed(2) + "px"
      );
    });

    if (stillMoving) {
      animationFrame = requestAnimationFrame(animate);
    } else {
      animationFrame = null;
    }
  }

  function handlePointerMove(event) {
    pointerX = event.clientX;
    pointerY = event.clientY;

    calculateTargets();
  }

  function handlePointerLeave() {
    pointerX = -10000;
    pointerY = -10000;

    states.forEach(function (state) {
      state.targetBlur = state.maximumBlur;
    });

    startAnimation();
  }

  function start() {
    initialiseAll(document);

    document.addEventListener(
      "pointermove",
      handlePointerMove,
      { passive: true }
    );

    document.documentElement.addEventListener(
      "mouseleave",
      handlePointerLeave
    );

    window.addEventListener(
      "scroll",
      calculateTargets,
      { passive: true }
    );

    window.addEventListener(
      "resize",
      calculateTargets,
      { passive: true }
    );

    document.addEventListener(
      "shopify:section:load",
      function (event) {
        initialiseAll(event.target);
      }
    );

    document.addEventListener(
      "shopify:block:select",
      function (event) {
        initialiseAll(event.target);
      }
    );

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            initialiseAll(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();